import React from 'react';
export const useScrollLock = () => { 
  const lockScroll = React.useCallback( (lock: boolean)=> { 
    if(lock) document.body.style.overflow = 'hidden';
    else document.body.style.overflow = '';
  }, [])

  return { lockScroll };  
}